import { gql } from 'graphql.macro';

const notificationMessageDataFragment = gql`
    fragment notificationMessageDataFields on NotificationMessageData {
        messageInfo
        subjectId
        extraInfo
    }
`;

export const notificationFragment = gql`
    fragment notificationFields on Notification {
        _id
        type
        messageData {
            ...notificationMessageDataFields
        }
        isRead
        isDone
        doneAt
        resolution {
            comment
            updatedAt
        }
        createdAt
        responsibleLabUser {
            _id
            fullName
        }
        originator {
            _id
            name {
                firstName
                lastName
            }
            fullName
            organization {
                _id
                name
            }
        }
    }
    ${notificationMessageDataFragment}
`;
